import { LoadingContextProvider } from "./LoadingContext";
import { LoginContextProvider } from "./LoginContext";
import { ShoppingCartContextProvider } from "./ShoppingCartContext";
import { SupportedDeviceContextProvider } from "./SupportedDeviceContext";

const ContextList = [
  // { name: "DeviceContextProvider", context: DeviceContextProvider },
  { name: "LoadingContext", context: LoadingContextProvider },
  { name: "ShoppingCartContext", context: ShoppingCartContextProvider },
];

function Context(props: any) {
  let output = props.children;
  ContextList.forEach((contextInfo) => {
    output = <contextInfo.context>{output}</contextInfo.context>;
  });
  return output;
}

export {
  LoadingContextProvider,
  LoginContextProvider,
  ShoppingCartContextProvider,
  SupportedDeviceContextProvider,
};

export default Context;
